function initLatestNews() {
  const featuredProducts = document.querySelector('.section-latest-news');
  if(!featuredProducts) return;

  const featuredProductsSlider = new Swiper('.latest-news-slider', {
    slidesPerView: 1.1,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3
      }
    },
    navigation: {
      prevEl: '.latest-news-slider__button.prev',
      nextEl: '.latest-news-slider__button.next',
    },
    pagination: {
      el: '.latest-news-slider__pagination',
      type: 'bullets',
      clickable: true
    }
  });
}

window.addEventListener('load', initLatestNews);